import React from 'react';
import { Field } from 'redux-form';
import TravellerMedicalField from './components/TravellerMedicalField/TravellerMedicalField';

const TravellersMedicalArray = ({
  fields,
  travellerStartIndex,
  region,
  tripType,
  destinations,
  onClearError
}) => {
  return (
    <>
      {fields.map((field, index) => (
        <Field
          key={field}
          name={field}
          component={TravellerMedicalField}
          index={travellerStartIndex + index + 1}
          region={region}
          tripType={tripType}
          destinations={destinations}
          onClearError={onClearError}
        />
      ))}
    </>
  );
};

export default TravellersMedicalArray;
